<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button>
<div mat-dialog-title>Portfolios restricted from automated rebalancing</div>
<mat-dialog-content class="irb-dialog">
    <mat-card class="block warn">
        <mat-card-title style="white-space: pre-line;">{{portfolios.length}} {{(portfolios.length === 1) ? 'portfolio contains': 'portfolios contain' }} accounts with Cash Up Front or Settled Cash Up Front restrictions. Only Cash management rebalance types can be chosen for automation.</mat-card-title>
    </mat-card>
    <div style="margin-bottom: 10px;border-top: solid 1px #cccccc; padding-top:5px;">
            Although selected, these portfolios will not be enabled for automated rebalancing.
    </div>

    <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'120px'"
            [style.minHeight]="'60px'"
            [style.maxHeight]="'210px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            [frameworkComponents] = 'gridOptions.frameworkComponents'
            [rowData] = 'portfolios'
            (gridReady) = "onGridReady($event)"></irb-inventory-grid>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
    <button mat-button class="btn-medium-primary green" (click)="editSelectedPortfolios()">Continue</button>
</mat-dialog-actions>
